import { createApp } from 'vue'
import ProductList from './ProductList'

const el = '.kb-component--product-list'
const DOMs = document.querySelectorAll(el)

export default function (Store) {
    if (DOMs && DOMs.length) {
        DOMs.forEach((DOM) => {
            const guid = DOM.dataset.guid
            const type = DOM.dataset.type
            const firstPageSize = parseInt(DOM.dataset.firstPageSize) ?? 20
            const showMorePageSize =
                parseInt(DOM.dataset.showMorePageSize) ?? 20
            const spotCardData = DOM.dataset.spotCard
                ? JSON.parse(DOM.dataset.spotCard)
                : null
            const avoidSetQueryInUrl = DOM.hasAttribute(
                'avoid-set-query-in-url'
            )
            const hideNoResults = DOM.hasAttribute('hide-no-results')
            const webshopContext = DOM.dataset.webshopContext

            const props = {
                guid,
                type,
                firstPageSize,
                showMorePageSize,
                spotCardData,
                avoidSetQueryInUrl,
                hideNoResults,
                webshopContext
            }
            const component = createApp(ProductList, props).use(Store)

            const mountOn = DOM.id ? `#${DOM.id}` : el
            component.mount(mountOn)
        })
    }
}
